@if (enabled) {
  <button
    class="transparent-btn"
    (click)="cancelLeadModal.openModal()"
    ngbTooltip="Annuler la demande"
    i18n-ngbTooltip
  >
    <app-trash-2-icon height="16px" width="16px" color="var(--error-600)" />
  </button>
  <app-action-modal
    #cancelLeadModal
    [disabled]="submitted"
    (submitted)="cancelLead()"
    [showHeader]="true"
    headerIconState="error"
    size="md"
  >
    <app-trash-icon
      height="16px"
      width="16px"
      color="var(--error-600)"
      headerIcon
    />
    <ng-container mainTitle i18n
      >Êtes-vous certain de vouloir annuler la demande ?</ng-container
    >
    <ng-container submitButtonLabel i18n>Confirmer</ng-container>
  </app-action-modal>
}
